import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';

export function mapScope(scope) {
  const {
    accountId,
    adGroupId,
    campaignId,
    customerId,
  } = scope;
  let levelAt = levelAtConstant.CUSTOMER;
  let entityIds = [customerId];

  if (adGroupId) {
    levelAt = levelAtConstant.ADGROUP;
    entityIds = [adGroupId];
  } else if (campaignId) {
    levelAt = levelAtConstant.CAMPAIGN;
    entityIds = [campaignId];
  } else if (accountId) {
    levelAt = levelAtConstant.ACCOUNT;
    entityIds = [accountId];
  }

  return _.defaults({}, scope, {
    levelAt,
    entityIds,
  });
}

export const withRecommendationsScope = (WrappedComponent) => {
  const HoC = (props) => {
    const scope = !_.isEmpty(props.scope) ? mapScope(props.scope) : null;
    const key = scope ?
      _.first(scope.entityIds) || scope.levelAt :
      '';
    return (
      <WrappedComponent
        // Currently the Recommendations feature can't handle a change
        // in scope, therefore withRecommendationsScope changes the key when scope changes
        // to create a new component.
        {...props}
        key={key}
        scope={scope}
      />
    );
  };

  HoC.displayName = `withRecommendationsScope(${getDisplayName(WrappedComponent)})`;
  HoC.propTypes = {
    scope: PropTypes.shape({
      accountId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      adGroupId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      campaignId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      customerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      token: PropTypes.string,
    }),
  };
  HoC.defaultProps = {
    scope: null,
  };

  hoistNonReactStatics(HoC, WrappedComponent);

  return HoC;
};
